// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"edc536e4","239":"bb54357d","455":"96cf0a82"}[chunkId] + ".chunk.js";
};